import { Controller } from "stimulus"

// Nieuwe ticket 3 (#1354): een set in de sportersomgeving. Gewicht en
// herhalingen slaan zichzelf op zodra het veld verandert (via Turbo, zodat de
// server de volgende sets kan bijwerken), en bij het aantikken wordt de
// waarde geselecteerd zodat de sporter meteen kan overtypen.
export default class extends Controller {
  static targets = ["formulier"]

  opslaan(event) {
    const form = event.target.closest("form")
    if (form) form.requestSubmit()
  }

  selecteer(event) {
    const veld = event.target
    requestAnimationFrame(() => veld.select())
  }
}
